import { __decorate } from "tslib";
import { FrontendFeaturePlugin, provideRootRoutes } from '@core/frontend-shared';
import { ClassName } from '@core/shared/class-name';
import { VPropertyHelper } from '@core/shared/virtual-properties';
import { SendMailModelActionService } from './model-actions';
import * as i0 from "@angular/core";
let MailerFrontendAdminFeature = /*#__PURE__*/(() => {
  let MailerFrontendAdminFeature = class MailerFrontendAdminFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@common/mailer/frontend-admin","featureId":"common-mailer"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineMenuItems({
        adminToolbar: [{
          label: 'Mail schreiben',
          priority: 1,
          routerLink: 'mailer',
          icon: 'envelope-open-text'
        }]
      });
      const adminCrudContextMatcher = [['admin', 'crud']];
      functionality.defineItemActions([{
        modelId: 'UserItem',
        displayContext: adminCrudContextMatcher,
        label: 'E-Mail schreiben',
        icon: "envelope-open-text",
        enableIf: item => {
          return item.email;
        },
        action: item => {
          const name = item.name || item.firstName + ' ' + item.lastName;
          this.injector.get(SendMailModelActionService).openMailerForUser(item.id, name);
        }
      }, {
        modelId: 'FeedbackItem',
        displayContext: adminCrudContextMatcher,
        label: 'Antwort verfassen',
        icon: "envelope-open-text",
        action: item => {
          const isUser = !!item.ownerId;
          const service = this.injector.get(SendMailModelActionService);
          // Fix #86c4gxj0c: it is possible a UserItem has no email address assigned. 
          // In this case, we need to use the mail address submitted in the form.
          const mailerCanWorkWithUserItem = isUser && item.email;
          if (mailerCanWorkWithUserItem) service.openMailerForUser(item.ownerId, item.name);else service.openMailerForCustomRecipient(item.email, item.name);
        }
      }, {
        modelId: 'DemoRequestItem',
        displayContext: adminCrudContextMatcher,
        label: 'Antwort verfassen',
        icon: "envelope-open-text",
        action: item => {
          this.injector.get(SendMailModelActionService).openMailerForUser(item.email, item.name);
        }
      }, {
        modelId: 'WaitingListItem',
        displayContext: adminCrudContextMatcher,
        label: 'Antwort verfassen',
        icon: "envelope-open-text",
        action: item => {
          this.injector.get(SendMailModelActionService).openMailerForUser(item.email, item.name);
        }
      }, {
        modelId: 'CompanyItem',
        displayContext: adminCrudContextMatcher,
        label: 'E-Mail an Ansprechpartner',
        icon: "envelope-open-text",
        enableIf: item => {
          return VPropertyHelper.has(item, 'contact_email') && VPropertyHelper.has(item, 'contact_name');
        },
        action: item => {
          this.injector.get(SendMailModelActionService).openMailerForCustomRecipient(VPropertyHelper.get(item, 'contact_email'), VPropertyHelper.get(item, 'contact_name'));
        }
      }, {
        modelId: 'CompanyEmployeesStatisticsEntry',
        displayContext: ['admin'],
        label: 'E-Mail an Ansprechpartner',
        icon: "envelope-open-text",
        styleClass: "ui-button-contrast",
        enableIf: item => {
          return VPropertyHelper.has(item.company, 'contact_email') && VPropertyHelper.has(item.company, 'contact_name');
        },
        action: item => {
          this.injector.get(SendMailModelActionService).openMailerForCustomRecipient(VPropertyHelper.get(item.company, 'contact_email'), VPropertyHelper.get(item.company, 'contact_name'));
        }
      }]);
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵMailerFrontendAdminFeature_BaseFactory;
        return function MailerFrontendAdminFeature_Factory(__ngFactoryType__) {
          return (ɵMailerFrontendAdminFeature_BaseFactory || (ɵMailerFrontendAdminFeature_BaseFactory = i0.ɵɵgetInheritedFactory(MailerFrontendAdminFeature)))(__ngFactoryType__ || MailerFrontendAdminFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: MailerFrontendAdminFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideRootRoutes([{
          path: 'mailer',
          loadChildren: () => import('./mailer-admin.module').then(m => m.MailerFrontendAdminModule)
        }])]
      });
    }
  };
  MailerFrontendAdminFeature = __decorate([ClassName("MailerFrontendAdminFeature")], MailerFrontendAdminFeature);
  return MailerFrontendAdminFeature;
})();
export { MailerFrontendAdminFeature };